import * as actionTypes from "./actionTypes";
import axios from "../../axios-amps";
import { logFirebaseEvent } from "../../shared/utility";
import { serverconfigs } from "../../constants";

export const submitDAFStarted = () => {
  return {
    type: actionTypes.POST_DAF_STARTED,
  };
};
export const submitDAFSuccess = () => {
  return {
    type: actionTypes.POST_DAF_SUCCESS,
  };
};
export const submitDAFFailed = (errorMessage) => {
  return {
    type: actionTypes.POST_DAF_FAILED,
    errorMessage: errorMessage,
  };
};

export const submitDAF = (formdata: FormData) => {
  return (dispatch) => {
    dispatch(submitDAFStarted());
    axios
      .post(serverconfigs.submitDAFUrl, formdata, {
        headers: {
          "content-type": "multipart/form-data",
        },
      })
      .then((response) => {
        console.log(response.data);
        dispatch(submitDAFSuccess());
      })
      .catch((error) => {
        if (error.statusCode === 400) {
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            dispatch(submitDAFFailed(error.response.data.message));
          } else {
            dispatch(submitDAFFailed(error.message));
          }
          logFirebaseEvent("Exception400");
        } else if (error.statusCode === 401) {
          logFirebaseEvent("Exception401");
          dispatch(submitDAFFailed(error.message));
        } else if (error.statusCode === 500) {
          logFirebaseEvent("Exception500");
          dispatch(submitDAFFailed(error.message));
        } else dispatch(submitDAFFailed(error.message));
      });
  };
};
